import {
  InventoryCountWithData,
  InventoryCountWithProducts,
} from "@/interfaces";
import { roundCurrency } from "@/utils";

export class InventoryCountHelper {
  static getDiscrepancy = (inventoryCount?: InventoryCountWithData) =>
    roundCurrency(
      (inventoryCount?.counted || 0) - (inventoryCount?.numberOfProducts || 0)
    );

  static getProductCounted = (
    inventoryCountWithProducts?: InventoryCountWithProducts
  ) =>
    inventoryCountWithProducts?.inventoryCountWithInventoryCountProducts?.reduce(
      (acc, product) => roundCurrency(acc + (product.counted || 0)),
      0
    ) || 0;

  static getProductDiscrepancy = (
    inventoryCountWithProducts?: InventoryCountWithProducts
  ) =>
    roundCurrency(
      InventoryCountHelper.getProductCounted(inventoryCountWithProducts) -
        (inventoryCountWithProducts?.inventoryCount || 0)
    );
}
